import { Button } from '@synoptic/ui-kit/button/button.tsx';
import {
  ModalContent,
  ModalHeader,
  ModalTitle,
} from '@synoptic/ui-kit/modal/modal.js';
import { useIsTablet } from '@synoptic/ui-kit/responsive/hooks.ts';
import { FC, useState } from 'react';
import {
  CancelSubscriptionForm,
  CancelSubscriptionFormInputs,
  CancelSubscriptionFormProps,
} from '@/components/streams/cancel-subscription/cancel-subscription-form.tsx';
import { modalList } from '@/components/streams/cancel-subscription/cancel-subscription.css.ts';
import { streamFormActions } from '@/components/streams/stream-form/stream-form.css.ts';

export type CancelSubscriptionModalContentProps = {
  onOpenChange: (open: boolean) => void;
};

export const CancelSubscriptionModalContent: FC<
  CancelSubscriptionModalContentProps & CancelSubscriptionFormProps
> = ({ onOpenChange, onSubmit }) => {
  const isTablet = useIsTablet();
  const [isSubscriptionCancelled, setIsSubscriptionCancelled] = useState(false);

  const handleSubmit = async (input: CancelSubscriptionFormInputs) => {
    await onSubmit(input);
    setIsSubscriptionCancelled(true);
  };

  return (
    <ModalContent>
      <ModalHeader>
        <ModalTitle>
          {!isSubscriptionCancelled
            ? 'Cancel subscription'
            : 'Your subscription has been canceled'}
        </ModalTitle>
      </ModalHeader>
      {!isSubscriptionCancelled ? (
        <CancelSubscriptionForm onSubmit={handleSubmit} />
      ) : (
        <div>
          <ul className={modalList}>
            <li>
              Your subscription has been canceled and you&apos;ll no longer be
              charged for it.
            </li>
            <li>
              You can have access to the content till the 1st day of the next
              billing cycle. You can resubscribe after the expiration date.
            </li>
          </ul>
          <div className={streamFormActions}>
            <Button
              size={isTablet ? 'large' : 'medium'}
              onClick={() => onOpenChange(false)}
            >
              Done
            </Button>
          </div>
        </div>
      )}
    </ModalContent>
  );
};
